
export class StarRateClicked {

    constructor(private newRate: number, private oldRate: number) {

    }

}
